// // import React, { useState, useEffect } from 'react';
// // import { Plus, X, Edit2, Trash2, ChevronDown, ChevronUp, DollarSign, Percent, Calendar, TrendingUp, Users } from 'lucide-react';

// // const AddPackage = () => {
// //   const [packages, setPackages] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [showAddForm, setShowAddForm] = useState(false);
// //   const [formData, setFormData] = useState({
// //     name: '',
// //     minInvestment: '',
// //     maxInvestment: 'Unlimited',
// //     durationDays: '365',
// //     dailyRoi: '',
// //     roiCreditDays: '5',
// //     workingDays: 'Mon-Fri',
// //     level1Percent: '',
// //     level2Percent: '',
// //     level3Percent: '',
// //     level4Percent: '',
// //     level5Percent: '',
// //     withdrawalFee: '',
// //     description: ''
// //   });

// //   const [editingId, setEditingId] = useState(null);
// //   const [expandedMobilePackage, setExpandedMobilePackage] = useState(null);
// //   const baseUrl = 'https://aerovolt-db464-default-rtdb.firebaseio.com/Packages';

// //   useEffect(() => {
// //     fetchPackages();
// //   }, []);

// //   const fetchPackages = async () => {
// //     try {
// //       setLoading(true);
// //       const response = await fetch(`${baseUrl}.json`);
// //       const data = await response.json();

// //       if (data) {
// //         const loadedPackages = Object.entries(data).map(([id, pkg]) => ({
// //           id,
// //           ...pkg
// //         }));
// //         setPackages(loadedPackages);
// //       } else {
// //         setPackages([]);
// //       }
// //     } catch (error) {
// //       console.error('Error fetching packages:', error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData(prev => ({
// //       ...prev,
// //       [name]: value
// //     }));
// //   };

// //   const resetForm = () => {
// //     setFormData({
// //       name: '',
// //       minInvestment: '',
// //       maxInvestment: 'Unlimited',
// //       durationDays: '365',
// //       dailyRoi: '',
// //       roiCreditDays: '5',
// //       workingDays: 'Mon-Fri',
// //       level1Percent: '',
// //       level2Percent: '',
// //       level3Percent: '',
// //       level4Percent: '',
// //       level5Percent: '',
// //       withdrawalFee: '',
// //       description: ''
// //     });
// //     setEditingId(null);
// //     setShowAddForm(false);
// //   };

// //   const calculateTotalCommission = () => {
// //     const levels = [
// //       formData.level1Percent || 0,
// //       formData.level2Percent || 0,
// //       formData.level3Percent || 0,
// //       formData.level4Percent || 0,
// //       formData.level5Percent || 0
// //     ];
// //     return levels.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     if (!formData.name?.trim() || !formData.minInvestment || !formData.dailyRoi) {
// //       alert('Please fill required fields: Name, Min Investment, Daily ROI');
// //       return;
// //     }

// //     const packageData = {
// //       name: formData.name.trim(),
// //       minInvestment: Number(formData.minInvestment),
// //       maxInvestment: formData.maxInvestment === 'Unlimited' ? 'Unlimited' : Number(formData.maxInvestment),
// //       durationDays: Number(formData.durationDays),
// //       dailyRoi: Number(formData.dailyRoi),
// //       roiCreditDays: Number(formData.roiCreditDays),
// //       workingDays: formData.workingDays,
// //       referralLevels: [
// //         Number(formData.level1Percent || 0),
// //         Number(formData.level2Percent || 0),
// //         Number(formData.level3Percent || 0),
// //         Number(formData.level4Percent || 0),
// //         Number(formData.level5Percent || 0)
// //       ],
// //       withdrawalFee: Number(formData.withdrawalFee || 0),
// //       description: formData.description || '',
// //       createdAt: new Date().toISOString(),
// //       totalCommission: calculateTotalCommission()
// //     };

// //     try {
// //       if (editingId) {
// //         await fetch(`${baseUrl}/${editingId}.json`, {
// //           method: 'PUT',
// //           headers: { 'Content-Type': 'application/json' },
// //           body: JSON.stringify({ ...packageData, updatedAt: new Date().toISOString() })
// //         });
// //       } else {
// //         const packageId = formData.name.toUpperCase().replace(/\s+/g, '_');
// //         await fetch(`${baseUrl}/${packageId}.json`, {
// //           method: 'PUT',
// //           headers: { 'Content-Type': 'application/json' },
// //           body: JSON.stringify(packageData)
// //         });
// //       }

// //       await fetchPackages();
// //       resetForm();
// //       alert(editingId ? 'Package updated!' : 'Package added!');
// //     } catch (error) {
// //       console.error('Error saving package:', error);
// //       alert('Failed to save package');
// //     }
// //   };

// //   const handleEdit = (pkg) => {
// //     setEditingId(pkg.id);
// //     setShowAddForm(true);
// //     setFormData({
// //       name: pkg.name || '',
// //       minInvestment: pkg.minInvestment || '',
// //       maxInvestment: pkg.maxInvestment || 'Unlimited',
// //       durationDays: pkg.durationDays || '365',
// //       dailyRoi: pkg.dailyRoi || '',
// //       roiCreditDays: pkg.roiCreditDays || '5',
// //       workingDays: pkg.workingDays || 'Mon-Fri',
// //       level1Percent: pkg.referralLevels?.[0] || '',
// //       level2Percent: pkg.referralLevels?.[1] || '',
// //       level3Percent: pkg.referralLevels?.[2] || '',
// //       level4Percent: pkg.referralLevels?.[3] || '',
// //       level5Percent: pkg.referralLevels?.[4] || '',
// //       withdrawalFee: pkg.withdrawalFee || '',
// //       description: pkg.description || ''
// //     });
// //   };

// //   const handleDelete = async (packageId) => {
// //     if (!window.confirm('Are you sure you want to delete this package?')) return;

// //     try {
// //       await fetch(`${baseUrl}/${packageId}.json`, { method: 'DELETE' });
// //       await fetchPackages();
// //       alert('Package deleted!');
// //     } catch (error) {
// //       console.error('Error deleting package:', error);
// //       alert('Failed to delete package');
// //     }
// //   };

// //   const predefinedPackages = [
// //     {
// //       name: 'PACKAGE 1',
// //       minInvestment: 16,
// //       maxInvestment: 999,
// //       durationDays: 365,
// //       dailyRoi: 1.5,
// //       roiCreditDays: 5,
// //       workingDays: 'Mon-Fri',
// //       referralLevels: [9, 7, 4, 2, 1],
// //       withdrawalFee: 10,
// //       description: 'Basic investment package'
// //     },
// //     {
// //       name: 'PACKAGE 2',
// //       minInvestment: 1000,
// //       maxInvestment: 4999,
// //       durationDays: 365,
// //       dailyRoi: 1.75,
// //       roiCreditDays: 5,
// //       workingDays: 'Mon-Fri',
// //       referralLevels: [11, 8, 5, 3, 2],
// //       withdrawalFee: 8,
// //       description: 'Standard investment package'
// //     },
// //     {
// //       name: 'PACKAGE 3',
// //       minInvestment: 5000,
// //       maxInvestment: 29999,
// //       durationDays: 365,
// //       dailyRoi: 2,
// //       roiCreditDays: 5,
// //       workingDays: 'Mon-Fri',
// //       referralLevels: [13, 10, 6, 4, 3],
// //       withdrawalFee: 6,
// //       description: 'Premium investment package'
// //     },
// //     {
// //       name: 'PACKAGE 4',
// //       minInvestment: 30000,
// //       maxInvestment: 69999,
// //       durationDays: 365,
// //       dailyRoi: 2.5,
// //       roiCreditDays: 5,
// //       workingDays: 'Mon-Fri',
// //       referralLevels: [15, 12, 7, 5, 4],
// //       withdrawalFee: 5,
// //       description: 'Elite investment package'
// //     },
// //     {
// //       name: 'PACKAGE 5',
// //       minInvestment: 70000,
// //       maxInvestment: 'Unlimited',
// //       durationDays: 365,
// //       dailyRoi: 3,
// //       roiCreditDays: 5,
// //       workingDays: 'Mon-Fri',
// //       referralLevels: [17, 14, 8, 6, 5],
// //       withdrawalFee: 4,
// //       description: 'Royal investment package'
// //     }
// //   ];

// //   const addPredefinedPackage = async (pkg) => {
// //     try {
// //       const packageId = pkg.name.toUpperCase().replace(/\s+/g, '_');
// //       await fetch(`${baseUrl}/${packageId}.json`, {
// //         method: 'PUT',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({
// //           ...pkg,
// //           totalCommission: pkg.referralLevels.reduce((a, b) => a + b, 0),
// //           createdAt: new Date().toISOString()
// //         })
// //       });
// //       await fetchPackages();
// //       alert(`${pkg.name} added successfully!`);
// //     } catch (error) {
// //       console.error('Error adding predefined package:', error);
// //       alert('Failed to add package');
// //     }
// //   };

// //   const formatCurrency = (amount) => {
// //     if (amount === 'Unlimited') return 'Unlimited';
// //     if (!amount && amount !== 0) return '';
// //     return new Intl.NumberFormat('en-US', {
// //       style: 'currency',
// //       currency: 'USD',
// //       minimumFractionDigits: 0,
// //       maximumFractionDigits: 0
// //     }).format(amount);
// //   };

// //   const getPackageColor = (name) => {
// //     switch(name) {
// //       case 'PACKAGE 1': return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
// //       case 'PACKAGE 2': return 'bg-green-500/20 text-green-400 border-green-500/30';
// //       case 'PACKAGE 3': return 'bg-purple-500/20 text-purple-400 border-purple-500/30';
// //       case 'PACKAGE 4': return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
// //       case 'PACKAGE 5': return 'bg-red-500/20 text-red-400 border-red-500/30';
// //       default: return 'bg-primary/20 text-primary border-primary/30';
// //     }
// //   };

// //   const toggleMobilePackage = (id) => {
// //     setExpandedMobilePackage(expandedMobilePackage === id ? null : id);
// //   };

// //   // Desktop Table Row Component
// //   const DesktopTableRow = ({ pkg }) => (
// //     <tr key={pkg.id} className="hover:bg-secondary/30 transition-colors">
// //       <td className="py-3 px-3">
// //         <div className="flex flex-col">
// //           <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getPackageColor(pkg.name)} font-body max-w-fit`}>
// //             {pkg.name}
// //           </span>
// //           {pkg.description && (
// //             <div className="text-xs text-muted-foreground mt-1 font-body truncate max-w-[150px]">
// //               {pkg.description}
// //             </div>
// //           )}
// //         </div>
// //       </td>
// //       <td className="py-3 px-3">
// //         <div className="flex flex-col">
// //           <div className="text-sm text-silver-light font-body">
// //             {formatCurrency(pkg.minInvestment)}
// //           </div>
// //           <div className="text-xs text-muted-foreground font-body">Min</div>
// //         </div>
// //       </td>
// //       <td className="py-3 px-3">
// //         <div className="flex flex-col">
// //           <div className="text-sm text-silver-light font-body">
// //             {pkg.maxInvestment === 'Unlimited' ? 'Unlimited' : formatCurrency(pkg.maxInvestment)}
// //           </div>
// //           <div className="text-xs text-muted-foreground font-body">Max</div>
// //         </div>
// //       </td>
// //       <td className="py-3 px-3">
// //         <div className="flex items-center gap-1">
// //           <TrendingUp className="h-3 w-3 text-green-400" />
// //           <span className="text-sm text-green-400 font-body">{pkg.dailyRoi}%</span>
// //         </div>
// //       </td>
// //       <td className="py-3 px-3">
// //         <div className="text-xs text-muted-foreground font-body">{pkg.durationDays} days</div>
// //       </td>
// //       <td className="py-3 px-3">
// //         <div className="flex items-center gap-1">
// //           <Users className="h-3 w-3 text-primary" />
// //           <span className="text-xs text-silver-light font-body">
// //             {pkg.referralLevels?.slice(0, 3).join('/')}%
// //           </span>
// //         </div>
// //       </td>
// //       <td className="py-3 px-3">
// //         <div className="flex items-center gap-1">
// //           <Percent className="h-3 w-3 text-red-400" />
// //           <span className="text-xs text-red-400 font-body">{pkg.withdrawalFee}%</span>
// //         </div>
// //       </td>
// //       <td className="py-3 px-3">
// //         <div className="flex gap-2">
// //           <button
// //             onClick={() => handleEdit(pkg)}
// //             className="px-3 py-1 bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 rounded-lg transition-colors border border-blue-500/30 text-xs font-body"
// //             title="Edit"
// //           >
// //             <Edit2 size={14} />
// //           </button>
// //           <button
// //             onClick={() => handleDelete(pkg.id)}
// //             className="px-3 py-1 bg-red-600/20 hover:bg-red-600/30 text-red-400 rounded-lg transition-colors border border-red-500/30 text-xs font-body"
// //             title="Delete"
// //           >
// //             <Trash2 size={14} />
// //           </button>
// //         </div>
// //       </td>
// //     </tr>
// //   );

// //   // Mobile Accordion Item Component
// //   const MobileAccordionItem = ({ pkg, index }) => (
// //     <div key={pkg.id} className="card-glow mb-4 overflow-hidden">
// //       <div 
// //         className="p-4 bg-secondary hover:bg-secondary/80 transition-colors cursor-pointer flex justify-between items-center"
// //         onClick={() => toggleMobilePackage(pkg.id)}
// //       >
// //         <div className="flex items-center gap-3">
// //           <span className="text-silver font-body text-sm">#{index + 1}</span>
// //           <div className="text-left">
// //             <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${getPackageColor(pkg.name)} font-body`}>
// //               {pkg.name}
// //             </span>
// //             <div className="mt-1 text-xs text-muted-foreground font-body">
// //               {formatCurrency(pkg.minInvestment)} - {pkg.maxInvestment === 'Unlimited' ? 'Unlimited' : formatCurrency(pkg.maxInvestment)}
// //             </div>
// //           </div>
// //         </div>
// //         <ChevronDown className={`h-5 w-5 text-silver transition-transform ${
// //           expandedMobilePackage === pkg.id ? 'rotate-180' : ''
// //         }`} />
// //       </div>
      
// //       {expandedMobilePackage === pkg.id && (
// //         <div className="p-4 border-t border-border">
// //           {/* Package Details */}
// //           <div className="grid grid-cols-2 gap-3 mb-4">
// //             <div className="bg-secondary/50 p-3 rounded-lg">
// //               <div className="text-xs text-silver font-body mb-1">Daily ROI</div>
// //               <div className="text-green-400 font-body flex items-center">
// //                 <TrendingUp className="h-3 w-3 mr-1" />
// //                 {pkg.dailyRoi}%
// //               </div>
// //             </div>
// //             <div className="bg-secondary/50 p-3 rounded-lg">
// //               <div className="text-xs text-silver font-body mb-1">Duration</div>
// //               <div className="text-foreground font-body flex items-center">
// //                 <Calendar className="h-3 w-3 mr-1 text-muted-foreground" />
// //                 {pkg.durationDays}d
// //               </div>
// //             </div>
// //             <div className="bg-secondary/50 p-3 rounded-lg">
// //               <div className="text-xs text-silver font-body mb-1">Withdrawal Fee</div>
// //               <div className="text-red-400 font-body flex items-center">
// //                 <Percent className="h-3 w-3 mr-1" />
// //                 {pkg.withdrawalFee}%
// //               </div>
// //             </div>
// //             <div className="bg-secondary/50 p-3 rounded-lg">
// //               <div className="text-xs text-silver font-body mb-1">Total Commission</div>
// //               <div className="text-primary font-body font-bold">
// //                 {pkg.totalCommission || pkg.referralLevels?.reduce((a, b) => a + b, 0)}%
// //               </div>
// //             </div>
// //           </div>
          
// //           {/* Referral Levels */}
// //           <div className="mb-4">
// //             <div className="flex items-center gap-2 mb-2">
// //               <Users className="h-4 w-4 text-primary" />
// //               <h4 className="font-semibold text-foreground font-heading text-sm">Referral Levels</h4>
// //             </div>
// //             <div className="grid grid-cols-5 gap-2">
// //               {pkg.referralLevels?.map((percent, index) => (
// //                 <div key={index} className="bg-secondary p-2 rounded-lg">
// //                   <div className="text-xs text-silver font-body text-center">L{index + 1}</div>
// //                   <div className="text-sm font-bold text-foreground font-heading text-center">
// //                     {percent}%
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
          
// //           {/* Description */}
// //           {pkg.description && (
// //             <div className="mb-4 p-3 bg-secondary/30 rounded-lg">
// //               <div className="text-xs text-silver font-body mb-1">Description</div>
// //               <div className="text-sm text-foreground font-body">{pkg.description}</div>
// //             </div>
// //           )}
          
// //           {/* Actions */}
// //           <div className="flex gap-2 pt-4 border-t border-border">
// //             <button
// //               onClick={() => handleEdit(pkg)}
// //               className="flex-1 px-4 py-2 bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 rounded-lg transition-colors font-body flex items-center justify-center text-sm"
// //             >
// //               <Edit2 className="h-4 w-4 mr-2" />
// //               Edit
// //             </button>
// //             <button
// //               onClick={() => handleDelete(pkg.id)}
// //               className="flex-1 px-4 py-2 bg-red-600/20 hover:bg-red-600/30 text-red-400 rounded-lg transition-colors font-body flex items-center justify-center text-sm"
// //             >
// //               <Trash2 className="h-4 w-4 mr-2" />
// //               Delete
// //             </button>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );

// //   return (
// //     <div className="container-custom space-y-8">
// //       {/* Header */}
// //       <div className="flex justify-between items-center">
// //         <div>
// //           <h1 className="text-2xl md:text-3xl font-bold text-foreground font-heading">Manage Packages</h1>
// //           <p className="text-muted-foreground font-body text-sm md:text-base">Configure investment packages and commissions</p>
// //         </div>
// //         <button
// //           onClick={() => setShowAddForm(!showAddForm)}
// //           className="btn-electric flex items-center gap-2 px-4 py-2 md:px-6 md:py-3 font-bold rounded-xl text-sm md:text-base"
// //         >
// //           {showAddForm ? <X size={18} /> : <Plus size={18} />}
// //           {showAddForm ? 'Cancel' : 'Add Package'}
// //         </button>
// //       </div>

// //       {/* Quick Add Predefined Packages */}
// //       <div className="card-glow p-4 md:p-6">
// //         <h2 className="text-lg md:text-xl font-bold text-foreground mb-4 font-heading">Quick Add Packages</h2>
// //         <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
// //           {predefinedPackages.map((pkg, index) => (
// //             <button
// //               key={index}
// //               onClick={() => addPredefinedPackage(pkg)}
// //               className="card-glow p-3 md:p-4 text-left transition-all hover:scale-105 hover:shadow-electric"
// //             >
// //               <div className="font-bold text-foreground font-heading text-sm md:text-base">{pkg.name}</div>
// //               <div className="text-xs md:text-sm text-primary mt-1 font-body">
// //                 ${pkg.minInvestment} - ${pkg.maxInvestment}
// //               </div>
// //               <div className="text-xs text-muted-foreground mt-2 font-body">
// //                 ROI: {pkg.dailyRoi}% | Levels: {pkg.referralLevels.slice(0, 3).join('/')}%
// //               </div>
// //             </button>
// //           ))}
// //         </div>
// //       </div>

// //       {/* Add/Edit Form */}
// //       {showAddForm && (
// //         <div className="card-glow p-4 md:p-8">
// //           <h2 className="text-xl md:text-2xl font-bold text-foreground mb-6 font-heading">
// //             {editingId ? 'Edit Package' : 'Add New Package'}
// //           </h2>
          
// //           <form onSubmit={handleSubmit} className="space-y-6">
// //             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
// //               {/* Package Name */}
// //               <div>
// //                 <label className="block text-silver mb-2 font-body text-sm">Package Name *</label>
// //                 <input
// //                   type="text"
// //                   name="name"
// //                   value={formData.name}
// //                   onChange={handleChange}
// //                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
// //                   placeholder="e.g., PACKAGE 1"
// //                   required
// //                 />
// //               </div>

// //               {/* Min Investment */}
// //               <div>
// //                 <label className="block text-silver mb-2 font-body text-sm">Min Investment ($) *</label>
// //                 <input
// //                   type="number"
// //                   name="minInvestment"
// //                   value={formData.minInvestment}
// //                   onChange={handleChange}
// //                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
// //                   required
// //                   min="0"
// //                 />
// //               </div>

// //               {/* Max Investment */}
// //               <div>
// //                 <label className="block text-silver mb-2 font-body text-sm">Max Investment</label>
// //                 <select
// //                   name="maxInvestment"
// //                   value={formData.maxInvestment}
// //                   onChange={handleChange}
// //                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
// //                 >
// //                   <option value="Unlimited">Unlimited</option>
// //                   <option value="999">$999</option>
// //                   <option value="4999">$4,999</option>
// //                   <option value="29999">$29,999</option>
// //                   <option value="69999">$69,999</option>
// //                 </select>
// //               </div>

// //               {/* Daily ROI */}
// //               <div>
// //                 <label className="block text-silver mb-2 font-body text-sm">Daily ROI (%) *</label>
// //                 <input
// //                   type="number"
// //                   step="0.01"
// //                   name="dailyRoi"
// //                   value={formData.dailyRoi}
// //                   onChange={handleChange}
// //                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
// //                   required
// //                 />
// //               </div>

// //               {/* Duration */}
// //               <div>
// //                 <label className="block text-silver mb-2 font-body text-sm">Duration (Days)</label>
// //                 <input
// //                   type="number"
// //                   name="durationDays"
// //                   value={formData.durationDays}
// //                   onChange={handleChange}
// //                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
// //                 />
// //               </div>

// //               {/* ROI Credit Days */}
// //               <div>
// //                 <label className="block text-silver mb-2 font-body text-sm">ROI Credit Every (Days)</label>
// //                 <input
// //                   type="number"
// //                   name="roiCreditDays"
// //                   value={formData.roiCreditDays}
// //                   onChange={handleChange}
// //                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
// //                 />
// //               </div>

// //               {/* Withdrawal Fee */}
// //               <div>
// //                 <label className="block text-silver mb-2 font-body text-sm">Withdrawal Fee (%)</label>
// //                 <input
// //                   type="number"
// //                   step="0.01"
// //                   name="withdrawalFee"
// //                   value={formData.withdrawalFee}
// //                   onChange={handleChange}
// //                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
// //                 />
// //               </div>
// //             </div>

// //             {/* Referral Levels */}
// //             <div className="bg-secondary/50 border border-border rounded-xl p-4 md:p-6 card-glow">
// //               <h3 className="text-lg md:text-xl font-bold text-foreground mb-4 font-heading">Referral Commission Levels</h3>
// //               <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
// //                 {[1, 2, 3, 4, 5].map(level => (
// //                   <div key={level}>
// //                     <label className="block text-silver mb-2 font-body text-sm">Level {level} (%)</label>
// //                     <input
// //                       type="number"
// //                       step="0.01"
// //                       name={`level${level}Percent`}
// //                       value={formData[`level${level}Percent`]}
// //                       onChange={handleChange}
// //                       className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
// //                       placeholder={`L${level} %`}
// //                     />
// //                   </div>
// //                 ))}
// //               </div>
// //               <div className="mt-4 text-right">
// //                 <span className="text-muted-foreground font-body text-sm md:text-base">Total Commission: </span>
// //                 <span className="text-xl md:text-2xl font-bold text-primary font-heading">
// //                   {calculateTotalCommission().toFixed(1)}%
// //                 </span>
// //               </div>
// //             </div>

// //             {/* Description */}
// //             <div>
// //               <label className="block text-silver mb-2 font-body text-sm">Description</label>
// //               <textarea
// //                 name="description"
// //                 value={formData.description}
// //                 onChange={handleChange}
// //                 rows="3"
// //                 className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
// //                 placeholder="Package description..."
// //               />
// //             </div>

// //             {/* Form Actions */}
// //             <div className="flex gap-4 pt-4">
// //               <button
// //                 type="submit"
// //                 className="btn-electric px-6 py-2 md:px-8 md:py-3 font-bold rounded-xl text-sm md:text-base"
// //               >
// //                 {editingId ? 'Update Package' : 'Create Package'}
// //               </button>
// //               <button
// //                 type="button"
// //                 onClick={resetForm}
// //                 className="px-6 py-2 md:px-8 md:py-3 bg-secondary hover:bg-secondary/80 text-foreground font-bold rounded-xl transition-colors border border-border text-sm md:text-base"
// //               >
// //                 Cancel
// //               </button>
// //             </div>
// //           </form>
// //         </div>
// //       )}

// //       {/* Desktop Table View */}
// //       <div className="hidden lg:block card-glow overflow-hidden">
// //         <div className="p-4 md:p-6 border-b border-border">
// //           <h2 className="text-xl font-bold text-foreground font-heading">Existing Packages ({packages.length})</h2>
// //         </div>

// //         {loading ? (
// //           <div className="p-8 text-center">
// //             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mx-auto"></div>
// //             <p className="text-muted-foreground mt-4 font-body">Loading packages...</p>
// //           </div>
// //         ) : packages.length === 0 ? (
// //           <div className="p-8 text-center text-muted-foreground font-body">
// //             No packages found. Add your first package.
// //           </div>
// //         ) : (
// //           <div className="overflow-x-auto">
// //             <table className="w-full min-w-max">
// //               <thead className="bg-secondary/50">
// //                 <tr>
// //                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-32">Package</th>
// //                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-24">Min</th>
// //                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-24">Max</th>
// //                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">ROI</th>
// //                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">Duration</th>
// //                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">Commissions</th>
// //                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">Fee</th>
// //                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-24">Actions</th>
// //                 </tr>
// //               </thead>
// //               <tbody className="divide-y divide-border">
// //                 {packages.map(pkg => (
// //                   <DesktopTableRow key={pkg.id} pkg={pkg} />
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         )}
// //       </div>

// //       {/* Mobile Accordion View */}
// //       <div className="lg:hidden">
// //         <div className="mb-4">
// //           <h2 className="text-xl font-bold text-foreground font-heading">Existing Packages ({packages.length})</h2>
// //         </div>

// //         {loading ? (
// //           <div className="p-8 text-center">
// //             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mx-auto"></div>
// //             <p className="text-muted-foreground mt-4 font-body">Loading packages...</p>
// //           </div>
// //         ) : packages.length === 0 ? (
// //           <div className="p-8 text-center text-muted-foreground font-body">
// //             No packages found. Add your first package.
// //           </div>
// //         ) : (
// //           <div>
// //             {packages.map((pkg, index) => (
// //               <MobileAccordionItem key={pkg.id} pkg={pkg} index={index} />
// //             ))}
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default AddPackage;


// import React, { useState, useEffect } from 'react';
// import { Plus, X, Edit2, Trash2, ChevronDown, ChevronUp, DollarSign, Percent, Calendar, TrendingUp, Users } from 'lucide-react';

// const AddPackage = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showAddForm, setShowAddForm] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     minInvestment: '',
//     maxInvestment: 'Unlimited',
//     durationDays: '365',
//     dailyRoi: '',
//     roiCreditDays: '5',
//     workingDays: 'Mon-Fri',
//     level1Percent: '',
//     level2Percent: '',
//     level3Percent: '',
//     level4Percent: '',
//     level5Percent: '',
//     withdrawalFee: '',
//     description: ''
//   });

//   const [editingId, setEditingId] = useState(null);
//   const [expandedMobilePackage, setExpandedMobilePackage] = useState(null);
//   const baseUrl = 'https://aerovolt-db464-default-rtdb.firebaseio.com/Packages';

//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const fetchPackages = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${baseUrl}.json`);
//       const data = await response.json();

//       if (data) {
//         const loadedPackages = Object.entries(data).map(([id, pkg]) => ({
//           id,
//           ...pkg
//         }));
//         setPackages(loadedPackages);
//       } else {
//         setPackages([]);
//       }
//     } catch (error) {
//       console.error('Error fetching packages:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const resetForm = () => {
//     setFormData({
//       name: '',
//       minInvestment: '',
//       maxInvestment: 'Unlimited',
//       durationDays: '365',
//       dailyRoi: '',
//       roiCreditDays: '5',
//       workingDays: 'Mon-Fri',
//       level1Percent: '',
//       level2Percent: '',
//       level3Percent: '',
//       level4Percent: '',
//       level5Percent: '',
//       withdrawalFee: '',
//       description: ''
//     });
//     setEditingId(null);
//     setShowAddForm(false);
//   };

//   const calculateTotalCommission = () => {
//     const levels = [
//       formData.level1Percent || 0,
//       formData.level2Percent || 0,
//       formData.level3Percent || 0,
//       formData.level4Percent || 0,
//       formData.level5Percent || 0
//     ];
//     return levels.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
//   };

//   // FIXED: Properly handle Unlimited value in database
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.name?.trim() || !formData.minInvestment || !formData.dailyRoi) {
//       alert('Please fill required fields: Name, Min Investment, Daily ROI');
//       return;
//     }

//     // CRITICAL FIX: Preserve "Unlimited" as string, not convert to number
//     let maxInvestmentValue;
//     if (formData.maxInvestment === 'Unlimited' || formData.maxInvestment === '') {
//       maxInvestmentValue = 'Unlimited'; // Store as string, not number
//     } else {
//       maxInvestmentValue = Number(formData.maxInvestment);
//     }

//     const packageData = {
//       name: formData.name.trim(),
//       minInvestment: Number(formData.minInvestment),
//       maxInvestment: maxInvestmentValue, // This will be "Unlimited" string or number
//       durationDays: Number(formData.durationDays),
//       dailyRoi: Number(formData.dailyRoi),
//       roiCreditDays: Number(formData.roiCreditDays),
//       workingDays: formData.workingDays,
//       referralLevels: [
//         Number(formData.level1Percent || 0),
//         Number(formData.level2Percent || 0),
//         Number(formData.level3Percent || 0),
//         Number(formData.level4Percent || 0),
//         Number(formData.level5Percent || 0)
//       ],
//       withdrawalFee: Number(formData.withdrawalFee || 0),
//       description: formData.description || '',
//       createdAt: new Date().toISOString(),
//       totalCommission: calculateTotalCommission()
//     };

//     try {
//       if (editingId) {
//         await fetch(`${baseUrl}/${editingId}.json`, {
//           method: 'PUT',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ 
//             ...packageData, 
//             updatedAt: new Date().toISOString() 
//           })
//         });
//       } else {
//         const packageId = formData.name.toUpperCase().replace(/\s+/g, '_');
//         await fetch(`${baseUrl}/${packageId}.json`, {
//           method: 'PUT',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(packageData)
//         });
//       }

//       await fetchPackages();
//       resetForm();
//       alert(editingId ? 'Package updated!' : 'Package added!');
//     } catch (error) {
//       console.error('Error saving package:', error);
//       alert('Failed to save package');
//     }
//   };

//   const handleEdit = (pkg) => {
//     setEditingId(pkg.id);
//     setShowAddForm(true);
    
//     // CRITICAL FIX: Handle Unlimited correctly when editing
//     let maxInvestmentValue = pkg.maxInvestment;
//     if (pkg.maxInvestment === 'Unlimited' || pkg.maxInvestment === 'Unlimited') {
//       maxInvestmentValue = 'Unlimited';
//     } else {
//       maxInvestmentValue = pkg.maxInvestment || 'Unlimited';
//     }

//     setFormData({
//       name: pkg.name || '',
//       minInvestment: pkg.minInvestment || '',
//       maxInvestment: maxInvestmentValue,
//       durationDays: pkg.durationDays || '365',
//       dailyRoi: pkg.dailyRoi || '',
//       roiCreditDays: pkg.roiCreditDays || '5',
//       workingDays: pkg.workingDays || 'Mon-Fri',
//       level1Percent: pkg.referralLevels?.[0] || '',
//       level2Percent: pkg.referralLevels?.[1] || '',
//       level3Percent: pkg.referralLevels?.[2] || '',
//       level4Percent: pkg.referralLevels?.[3] || '',
//       level5Percent: pkg.referralLevels?.[4] || '',
//       withdrawalFee: pkg.withdrawalFee || '',
//       description: pkg.description || ''
//     });
//   };

//   const handleDelete = async (packageId) => {
//     if (!window.confirm('Are you sure you want to delete this package?')) return;

//     try {
//       await fetch(`${baseUrl}/${packageId}.json`, { method: 'DELETE' });
//       await fetchPackages();
//       alert('Package deleted!');
//     } catch (error) {
//       console.error('Error deleting package:', error);
//       alert('Failed to delete package');
//     }
//   };

//   // FIXED: Predefined packages with Unlimited as string, not number
//   const predefinedPackages = [
//     {
//       name: 'PACKAGE 1',
//       minInvestment: 16,
//       maxInvestment: 999, // Number
//       durationDays: 365,
//       dailyRoi: 1.5,
//       roiCreditDays: 5,
//       workingDays: 'Mon-Fri',
//       referralLevels: [9, 7, 4, 2, 1],
//       withdrawalFee: 10,
//       description: 'Basic investment package'
//     },
//     {
//       name: 'PACKAGE 2',
//       minInvestment: 1000,
//       maxInvestment: 4999, // Number
//       durationDays: 365,
//       dailyRoi: 1.75,
//       roiCreditDays: 5,
//       workingDays: 'Mon-Fri',
//       referralLevels: [11, 8, 5, 3, 2],
//       withdrawalFee: 8,
//       description: 'Standard investment package'
//     },
//     {
//       name: 'PACKAGE 3',
//       minInvestment: 5000,
//       maxInvestment: 29999, // Number
//       durationDays: 365,
//       dailyRoi: 2,
//       roiCreditDays: 5,
//       workingDays: 'Mon-Fri',
//       referralLevels: [13, 10, 6, 4, 3],
//       withdrawalFee: 6,
//       description: 'Premium investment package'
//     },
//     {
//       name: 'PACKAGE 4',
//       minInvestment: 30000,
//       maxInvestment: 69999, // Number
//       durationDays: 365,
//       dailyRoi: 2.5,
//       roiCreditDays: 5,
//       workingDays: 'Mon-Fri',
//       referralLevels: [15, 12, 7, 5, 4],
//       withdrawalFee: 5,
//       description: 'Elite investment package'
//     },
//     {
//       name: 'PACKAGE 5',
//       minInvestment: 70000,
//       maxInvestment: 'Unlimited', // STRING - NOT NUMBER
//       durationDays: 365,
//       dailyRoi: 3,
//       roiCreditDays: 5,
//       workingDays: 'Mon-Fri',
//       referralLevels: [17, 14, 8, 6, 5],
//       withdrawalFee: 4,
//       description: 'Royal investment package - Unlimited maximum'
//     }
//   ];

//   // FIXED: Add predefined package with Unlimited as string
//   const addPredefinedPackage = async (pkg) => {
//     try {
//       const packageId = pkg.name.toUpperCase().replace(/\s+/g, '_');
      
//       // CRITICAL: Preserve Unlimited as string, not convert to number
//       const packageData = {
//         ...pkg,
//         maxInvestment: pkg.maxInvestment, // Keep as is (Unlimited stays string, numbers stay numbers)
//         totalCommission: pkg.referralLevels.reduce((a, b) => a + b, 0),
//         createdAt: new Date().toISOString()
//       };

//       await fetch(`${baseUrl}/${packageId}.json`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(packageData)
//       });
      
//       await fetchPackages();
//       alert(`${pkg.name} added successfully!`);
//     } catch (error) {
//       console.error('Error adding predefined package:', error);
//       alert('Failed to add package');
//     }
//   };

//   // FIXED: Format currency to handle Unlimited string
//   const formatCurrency = (amount) => {
//     if (amount === 'Unlimited' || amount === 'Unlimited' || amount === 'Unlimited') {
//       return 'Unlimited';
//     }
//     if (!amount && amount !== 0) return '';
//     if (typeof amount === 'string' && isNaN(Number(amount))) return amount;
    
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD',
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0
//     }).format(Number(amount));
//   };

//   // FIXED: Safely compare maxInvestment values
//   const isUnlimited = (value) => {
//     return value === 'Unlimited' || value === 'Unlimited' || value === 'Unlimited' || value === 'Unlimited';
//   };

//   const getPackageColor = (name) => {
//     switch(name) {
//       case 'PACKAGE 1': return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
//       case 'PACKAGE 2': return 'bg-green-500/20 text-green-400 border-green-500/30';
//       case 'PACKAGE 3': return 'bg-purple-500/20 text-purple-400 border-purple-500/30';
//       case 'PACKAGE 4': return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
//       case 'PACKAGE 5': return 'bg-red-500/20 text-red-400 border-red-500/30';
//       default: return 'bg-primary/20 text-primary border-primary/30';
//     }
//   };

//   const toggleMobilePackage = (id) => {
//     setExpandedMobilePackage(expandedMobilePackage === id ? null : id);
//   };

//   // Desktop Table Row Component
//   const DesktopTableRow = ({ pkg }) => (
//     <tr key={pkg.id} className="hover:bg-secondary/30 transition-colors">
//       <td className="py-3 px-3">
//         <div className="flex flex-col">
//           <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getPackageColor(pkg.name)} font-body max-w-fit`}>
//             {pkg.name}
//           </span>
//           {pkg.description && (
//             <div className="text-xs text-muted-foreground mt-1 font-body truncate max-w-[150px]">
//               {pkg.description}
//             </div>
//           )}
//         </div>
//       </td>
//       <td className="py-3 px-3">
//         <div className="flex flex-col">
//           <div className="text-sm text-silver-light font-body">
//             {formatCurrency(pkg.minInvestment)}
//           </div>
//           <div className="text-xs text-muted-foreground font-body">Min</div>
//         </div>
//       </td>
//       <td className="py-3 px-3">
//         <div className="flex flex-col">
//           <div className="text-sm text-silver-light font-body">
//             {isUnlimited(pkg.maxInvestment) ? 'Unlimited' : formatCurrency(pkg.maxInvestment)}
//           </div>
//           <div className="text-xs text-muted-foreground font-body">Max</div>
//         </div>
//       </td>
//       <td className="py-3 px-3">
//         <div className="flex items-center gap-1">
//           <TrendingUp className="h-3 w-3 text-green-400" />
//           <span className="text-sm text-green-400 font-body">{pkg.dailyRoi}%</span>
//         </div>
//       </td>
//       <td className="py-3 px-3">
//         <div className="text-xs text-muted-foreground font-body">{pkg.durationDays} days</div>
//       </td>
//       <td className="py-3 px-3">
//         <div className="flex items-center gap-1">
//           <Users className="h-3 w-3 text-primary" />
//           <span className="text-xs text-silver-light font-body">
//             {pkg.referralLevels?.slice(0, 3).join('/')}%
//           </span>
//         </div>
//       </td>
//       <td className="py-3 px-3">
//         <div className="flex items-center gap-1">
//           <Percent className="h-3 w-3 text-red-400" />
//           <span className="text-xs text-red-400 font-body">{pkg.withdrawalFee}%</span>
//         </div>
//       </td>
//       <td className="py-3 px-3">
//         <div className="flex gap-2">
//           <button
//             onClick={() => handleEdit(pkg)}
//             className="px-3 py-1 bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 rounded-lg transition-colors border border-blue-500/30 text-xs font-body"
//             title="Edit"
//           >
//             <Edit2 size={14} />
//           </button>
//           <button
//             onClick={() => handleDelete(pkg.id)}
//             className="px-3 py-1 bg-red-600/20 hover:bg-red-600/30 text-red-400 rounded-lg transition-colors border border-red-500/30 text-xs font-body"
//             title="Delete"
//           >
//             <Trash2 size={14} />
//           </button>
//         </div>
//       </td>
//     </tr>
//   );

//   // Mobile Accordion Item Component
//   const MobileAccordionItem = ({ pkg, index }) => (
//     <div key={pkg.id} className="card-glow mb-4 overflow-hidden">
//       <div 
//         className="p-4 bg-secondary hover:bg-secondary/80 transition-colors cursor-pointer flex justify-between items-center"
//         onClick={() => toggleMobilePackage(pkg.id)}
//       >
//         <div className="flex items-center gap-3">
//           <span className="text-silver font-body text-sm">#{index + 1}</span>
//           <div className="text-left">
//             <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${getPackageColor(pkg.name)} font-body`}>
//               {pkg.name}
//             </span>
//             <div className="mt-1 text-xs text-muted-foreground font-body">
//               {formatCurrency(pkg.minInvestment)} - {isUnlimited(pkg.maxInvestment) ? 'Unlimited' : formatCurrency(pkg.maxInvestment)}
//             </div>
//           </div>
//         </div>
//         <ChevronDown className={`h-5 w-5 text-silver transition-transform ${
//           expandedMobilePackage === pkg.id ? 'rotate-180' : ''
//         }`} />
//       </div>
      
//       {expandedMobilePackage === pkg.id && (
//         <div className="p-4 border-t border-border">
//           {/* Package Details */}
//           <div className="grid grid-cols-2 gap-3 mb-4">
//             <div className="bg-secondary/50 p-3 rounded-lg">
//               <div className="text-xs text-silver font-body mb-1">Daily ROI</div>
//               <div className="text-green-400 font-body flex items-center">
//                 <TrendingUp className="h-3 w-3 mr-1" />
//                 {pkg.dailyRoi}%
//               </div>
//             </div>
//             <div className="bg-secondary/50 p-3 rounded-lg">
//               <div className="text-xs text-silver font-body mb-1">Duration</div>
//               <div className="text-foreground font-body flex items-center">
//                 <Calendar className="h-3 w-3 mr-1 text-muted-foreground" />
//                 {pkg.durationDays}d
//               </div>
//             </div>
//             <div className="bg-secondary/50 p-3 rounded-lg">
//               <div className="text-xs text-silver font-body mb-1">Withdrawal Fee</div>
//               <div className="text-red-400 font-body flex items-center">
//                 <Percent className="h-3 w-3 mr-1" />
//                 {pkg.withdrawalFee}%
//               </div>
//             </div>
//             <div className="bg-secondary/50 p-3 rounded-lg">
//               <div className="text-xs text-silver font-body mb-1">Total Commission</div>
//               <div className="text-primary font-body font-bold">
//                 {pkg.totalCommission || pkg.referralLevels?.reduce((a, b) => a + b, 0)}%
//               </div>
//             </div>
//           </div>
          
//           {/* Referral Levels */}
//           <div className="mb-4">
//             <div className="flex items-center gap-2 mb-2">
//               <Users className="h-4 w-4 text-primary" />
//               <h4 className="font-semibold text-foreground font-heading text-sm">Referral Levels</h4>
//             </div>
//             <div className="grid grid-cols-5 gap-2">
//               {pkg.referralLevels?.map((percent, index) => (
//                 <div key={index} className="bg-secondary p-2 rounded-lg">
//                   <div className="text-xs text-silver font-body text-center">L{index + 1}</div>
//                   <div className="text-sm font-bold text-foreground font-heading text-center">
//                     {percent}%
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
          
//           {/* Description */}
//           {pkg.description && (
//             <div className="mb-4 p-3 bg-secondary/30 rounded-lg">
//               <div className="text-xs text-silver font-body mb-1">Description</div>
//               <div className="text-sm text-foreground font-body">{pkg.description}</div>
//             </div>
//           )}
          
//           {/* Actions */}
//           <div className="flex gap-2 pt-4 border-t border-border">
//             <button
//               onClick={() => handleEdit(pkg)}
//               className="flex-1 px-4 py-2 bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 rounded-lg transition-colors font-body flex items-center justify-center text-sm"
//             >
//               <Edit2 className="h-4 w-4 mr-2" />
//               Edit
//             </button>
//             <button
//               onClick={() => handleDelete(pkg.id)}
//               className="flex-1 px-4 py-2 bg-red-600/20 hover:bg-red-600/30 text-red-400 rounded-lg transition-colors font-body flex items-center justify-center text-sm"
//             >
//               <Trash2 className="h-4 w-4 mr-2" />
//               Delete
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );

//   return (
//     <div className="container-custom space-y-8">
//       {/* Header */}
//       <div className="flex justify-between items-center">
//         <div>
//           <h1 className="text-2xl md:text-3xl font-bold text-foreground font-heading">Manage Packages</h1>
//           <p className="text-muted-foreground font-body text-sm md:text-base">Configure investment packages and commissions</p>
//         </div>
//         <button
//           onClick={() => setShowAddForm(!showAddForm)}
//           className="btn-electric flex items-center gap-2 px-4 py-2 md:px-6 md:py-3 font-bold rounded-xl text-sm md:text-base"
//         >
//           {showAddForm ? <X size={18} /> : <Plus size={18} />}
//           {showAddForm ? 'Cancel' : 'Add Package'}
//         </button>
//       </div>

//       {/* Quick Add Predefined Packages */}
//       <div className="card-glow p-4 md:p-6">
//         <h2 className="text-lg md:text-xl font-bold text-foreground mb-4 font-heading">Quick Add Packages</h2>
//         <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
//           {predefinedPackages.map((pkg, index) => (
//             <button
//               key={index}
//               onClick={() => addPredefinedPackage(pkg)}
//               className="card-glow p-3 md:p-4 text-left transition-all hover:scale-105 hover:shadow-electric"
//             >
//               <div className="font-bold text-foreground font-heading text-sm md:text-base">{pkg.name}</div>
//               <div className="text-xs md:text-sm text-primary mt-1 font-body">
//                 ${pkg.minInvestment} - {pkg.maxInvestment === 'Unlimited' ? 'Unlimited' : `$${pkg.maxInvestment}`}
//               </div>
//               <div className="text-xs text-muted-foreground mt-2 font-body">
//                 ROI: {pkg.dailyRoi}% | Levels: {pkg.referralLevels.slice(0, 3).join('/')}%
//               </div>
//               {pkg.maxInvestment === 'Unlimited' && (
//                 <span className="mt-2 inline-flex items-center px-2 py-0.5 bg-red-500/20 text-red-400 text-xs rounded-full border border-red-500/30">
//                   Unlimited Max
//                 </span>
//               )}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Add/Edit Form */}
//       {showAddForm && (
//         <div className="card-glow p-4 md:p-8">
//           <h2 className="text-xl md:text-2xl font-bold text-foreground mb-6 font-heading">
//             {editingId ? 'Edit Package' : 'Add New Package'}
//           </h2>
          
//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
//               {/* Package Name */}
//               <div>
//                 <label className="block text-silver mb-2 font-body text-sm">Package Name *</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
//                   placeholder="e.g., PACKAGE 1"
//                   required
//                 />
//               </div>

//               {/* Min Investment */}
//               <div>
//                 <label className="block text-silver mb-2 font-body text-sm">Min Investment ($) *</label>
//                 <input
//                   type="number"
//                   name="minInvestment"
//                   value={formData.minInvestment}
//                   onChange={handleChange}
//                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
//                   required
//                   min="0"
//                 />
//               </div>

//               {/* Max Investment - FIXED: Unlimited option preserved */}
//               <div>
//                 <label className="block text-silver mb-2 font-body text-sm">Max Investment</label>
//                 <select
//                   name="maxInvestment"
//                   value={formData.maxInvestment}
//                   onChange={handleChange}
//                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
//                 >
//                   <option value="Unlimited">Unlimited</option>
//                   <option value="999">$999</option>
//                   <option value="4999">$4,999</option>
//                   <option value="29999">$29,999</option>
//                   <option value="69999">$69,999</option>
//                 </select>
//                 {formData.maxInvestment === 'Unlimited' && (
//                   <div className="mt-1 text-xs text-green-400">
//                     ✓ Will be saved as "Unlimited" in database
//                   </div>
//                 )}
//               </div>

//               {/* Daily ROI */}
//               <div>
//                 <label className="block text-silver mb-2 font-body text-sm">Daily ROI (%) *</label>
//                 <input
//                   type="number"
//                   step="0.01"
//                   name="dailyRoi"
//                   value={formData.dailyRoi}
//                   onChange={handleChange}
//                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
//                   required
//                 />
//               </div>

//               {/* Duration */}
//               <div>
//                 <label className="block text-silver mb-2 font-body text-sm">Duration (Days)</label>
//                 <input
//                   type="number"
//                   name="durationDays"
//                   value={formData.durationDays}
//                   onChange={handleChange}
//                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
//                 />
//               </div>

//               {/* ROI Credit Days */}
//               <div>
//                 <label className="block text-silver mb-2 font-body text-sm">ROI Credit Every (Days)</label>
//                 <input
//                   type="number"
//                   name="roiCreditDays"
//                   value={formData.roiCreditDays}
//                   onChange={handleChange}
//                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
//                 />
//               </div>

//               {/* Withdrawal Fee */}
//               <div>
//                 <label className="block text-silver mb-2 font-body text-sm">Withdrawal Fee (%)</label>
//                 <input
//                   type="number"
//                   step="0.01"
//                   name="withdrawalFee"
//                   value={formData.withdrawalFee}
//                   onChange={handleChange}
//                   className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
//                 />
//               </div>
//             </div>

//             {/* Referral Levels */}
//             <div className="bg-secondary/50 border border-border rounded-xl p-4 md:p-6 card-glow">
//               <h3 className="text-lg md:text-xl font-bold text-foreground mb-4 font-heading">Referral Commission Levels</h3>
//               <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
//                 {[1, 2, 3, 4, 5].map(level => (
//                   <div key={level}>
//                     <label className="block text-silver mb-2 font-body text-sm">Level {level} (%)</label>
//                     <input
//                       type="number"
//                       step="0.01"
//                       name={`level${level}Percent`}
//                       value={formData[`level${level}Percent`]}
//                       onChange={handleChange}
//                       className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
//                       placeholder={`L${level} %`}
//                     />
//                   </div>
//                 ))}
//               </div>
//               <div className="mt-4 text-right">
//                 <span className="text-muted-foreground font-body text-sm md:text-base">Total Commission: </span>
//                 <span className="text-xl md:text-2xl font-bold text-primary font-heading">
//                   {calculateTotalCommission().toFixed(1)}%
//                 </span>
//               </div>
//             </div>

//             {/* Description */}
//             <div>
//               <label className="block text-silver mb-2 font-body text-sm">Description</label>
//               <textarea
//                 name="description"
//                 value={formData.description}
//                 onChange={handleChange}
//                 rows="3"
//                 className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
//                 placeholder="Package description..."
//               />
//             </div>

//             {/* Form Actions */}
//             <div className="flex gap-4 pt-4">
//               <button
//                 type="submit"
//                 className="btn-electric px-6 py-2 md:px-8 md:py-3 font-bold rounded-xl text-sm md:text-base"
//               >
//                 {editingId ? 'Update Package' : 'Create Package'}
//               </button>
//               <button
//                 type="button"
//                 onClick={resetForm}
//                 className="px-6 py-2 md:px-8 md:py-3 bg-secondary hover:bg-secondary/80 text-foreground font-bold rounded-xl transition-colors border border-border text-sm md:text-base"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* Desktop Table View */}
//       <div className="hidden lg:block card-glow overflow-hidden">
//         <div className="p-4 md:p-6 border-b border-border">
//           <h2 className="text-xl font-bold text-foreground font-heading">Existing Packages ({packages.length})</h2>
//         </div>

//         {loading ? (
//           <div className="p-8 text-center">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mx-auto"></div>
//             <p className="text-muted-foreground mt-4 font-body">Loading packages...</p>
//           </div>
//         ) : packages.length === 0 ? (
//           <div className="p-8 text-center text-muted-foreground font-body">
//             No packages found. Add your first package.
//           </div>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="w-full min-w-max">
//               <thead className="bg-secondary/50">
//                 <tr>
//                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-32">Package</th>
//                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-24">Min</th>
//                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-24">Max</th>
//                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">ROI</th>
//                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">Duration</th>
//                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">Commissions</th>
//                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">Fee</th>
//                   <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-24">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-border">
//                 {packages.map(pkg => (
//                   <DesktopTableRow key={pkg.id} pkg={pkg} />
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* Mobile Accordion View */}
//       <div className="lg:hidden">
//         <div className="mb-4">
//           <h2 className="text-xl font-bold text-foreground font-heading">Existing Packages ({packages.length})</h2>
//         </div>

//         {loading ? (
//           <div className="p-8 text-center">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mx-auto"></div>
//             <p className="text-muted-foreground mt-4 font-body">Loading packages...</p>
//           </div>
//         ) : packages.length === 0 ? (
//           <div className="p-8 text-center text-muted-foreground font-body">
//             No packages found. Add your first package.
//           </div>
//         ) : (
//           <div>
//             {packages.map((pkg, index) => (
//               <MobileAccordionItem key={pkg.id} pkg={pkg} index={index} />
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddPackage;







import React, { useState, useEffect } from 'react';
import { Plus, X, Edit2, Trash2, ChevronDown, ChevronUp, DollarSign, Percent, Calendar, TrendingUp, Users } from 'lucide-react';

const AddPackage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    minInvestment: '',
    maxInvestment: 'Unlimited',
    durationDays: '365',
    dailyRoi: '',
    roiCreditDays: '5',
    workingDays: 'Mon-Fri',
    level1Percent: '',
    level2Percent: '',
    level3Percent: '',
    level4Percent: '',
    level5Percent: '',
    withdrawalFee: '',
    description: ''
  });
  const [activationBonusRule, setActivationBonusRule] = useState({
    enabled: true,
    requiredPackages: 3,
    windowDays: 45,
    bonusAmount: 15,
    wallet: 'working'
  });
  const [activationRuleStatus, setActivationRuleStatus] = useState({
    loading: true,
    saving: false
  });

  const [editingId, setEditingId] = useState(null);
  const [expandedMobilePackage, setExpandedMobilePackage] = useState(null);
  const baseUrl = 'https://aerovolt-db464-default-rtdb.firebaseio.com/Packages';
  const rulesUrl = 'https://aerovolt-db464-default-rtdb.firebaseio.com/Packages/packageRules';

  useEffect(() => {
    fetchPackages();
    fetchActivationBonusRule();
  }, []);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${baseUrl}.json`);
      const data = await response.json();

      if (data) {
        const loadedPackages = Object.entries(data).map(([id, pkg]) => ({
          id,
          ...pkg
        }));
        setPackages(loadedPackages);
      } else {
        setPackages([]);
      }
    } catch (error) {
      console.error('Error fetching packages:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchActivationBonusRule = async () => {
    try {
      setActivationRuleStatus((prev) => ({ ...prev, loading: true }));
      const response = await fetch(`${rulesUrl}.json`);
      const data = await response.json();
      if (data) {
        setActivationBonusRule({
          enabled: data.enabled !== false,
          requiredPackages: parseInt(data.requiredPackages, 10) || 3,
          windowDays: parseInt(data.windowDays, 10) || 45,
          bonusAmount: parseFloat(data.bonusAmount) || 15,
          wallet: data.wallet || 'working'
        });
      } else {
        setActivationBonusRule({
          enabled: true,
          requiredPackages: 3,
          windowDays: 45,
          bonusAmount: 15,
          wallet: 'working'
        });
      }
    } catch (error) {
      console.error('Error fetching activation bonus rule:', error);
    } finally {
      setActivationRuleStatus((prev) => ({ ...prev, loading: false }));
    }
  };

  const saveActivationBonusRule = async () => {
    try {
      setActivationRuleStatus((prev) => ({ ...prev, saving: true }));
      const payload = {
        enabled: Boolean(activationBonusRule.enabled),
        requiredPackages: parseInt(activationBonusRule.requiredPackages, 10) || 3,
        windowDays: parseInt(activationBonusRule.windowDays, 10) || 45,
        bonusAmount: parseFloat(activationBonusRule.bonusAmount) || 15,
        wallet: activationBonusRule.wallet || 'working',
        updatedAt: new Date().toISOString()
      };
      await fetch(`${rulesUrl}.json`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      alert('Activation bonus rule saved.');
    } catch (error) {
      console.error('Error saving activation bonus rule:', error);
      alert('Failed to save activation bonus rule.');
    } finally {
      setActivationRuleStatus((prev) => ({ ...prev, saving: false }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setFormData({
      name: '',
      minInvestment: '',
      maxInvestment: 'Unlimited',
      durationDays: '365',
      dailyRoi: '',
      roiCreditDays: '5',
      workingDays: 'Mon-Fri',
      level1Percent: '',
      level2Percent: '',
      level3Percent: '',
      level4Percent: '',
      level5Percent: '',
      withdrawalFee: '',
      description: ''
    });
    setEditingId(null);
    setShowAddForm(false);
  };

  const calculateTotalCommission = () => {
    const levels = [
      formData.level1Percent || 0,
      formData.level2Percent || 0,
      formData.level3Percent || 0,
      formData.level4Percent || 0,
      formData.level5Percent || 0
    ];
    return levels.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
  };

  // FIXED: Dynamically handle any value for maxInvestment
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name?.trim() || !formData.minInvestment || !formData.dailyRoi) {
      alert('Please fill required fields: Name, Min Investment, Daily ROI');
      return;
    }

    // CRITICAL FIX: Save maxInvestment exactly as entered - preserve any string
    const maxInvestmentValue = formData.maxInvestment; // Keep as is - can be "Unlimited", "Any", "∞", etc.

    const packageData = {
      name: formData.name.trim(),
      minInvestment: Number(formData.minInvestment),
      maxInvestment: maxInvestmentValue, // This will be whatever the user typed (string)
      durationDays: Number(formData.durationDays),
      dailyRoi: Number(formData.dailyRoi),
      roiCreditDays: Number(formData.roiCreditDays),
      workingDays: formData.workingDays,
      referralLevels: [
        Number(formData.level1Percent || 0),
        Number(formData.level2Percent || 0),
        Number(formData.level3Percent || 0),
        Number(formData.level4Percent || 0),
        Number(formData.level5Percent || 0)
      ],
      withdrawalFee: Number(formData.withdrawalFee || 0),
      description: formData.description || '',
      createdAt: new Date().toISOString(),
      totalCommission: calculateTotalCommission()
    };

    try {
      if (editingId) {
        await fetch(`${baseUrl}/${editingId}.json`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            ...packageData, 
            updatedAt: new Date().toISOString() 
          })
        });
      } else {
        const packageId = formData.name.toUpperCase().replace(/\s+/g, '_');
        await fetch(`${baseUrl}/${packageId}.json`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(packageData)
        });
      }

      await fetchPackages();
      resetForm();
      alert(editingId ? 'Package updated!' : 'Package added!');
    } catch (error) {
      console.error('Error saving package:', error);
      alert('Failed to save package');
    }
  };

  const handleEdit = (pkg) => {
    setEditingId(pkg.id);
    setShowAddForm(true);
    
    // FIXED: Handle any value for maxInvestment when editing
    const maxInvestmentValue = pkg.maxInvestment || 'Unlimited';

    setFormData({
      name: pkg.name || '',
      minInvestment: pkg.minInvestment || '',
      maxInvestment: maxInvestmentValue,
      durationDays: pkg.durationDays || '365',
      dailyRoi: pkg.dailyRoi || '',
      roiCreditDays: pkg.roiCreditDays || '5',
      workingDays: pkg.workingDays || 'Mon-Fri',
      level1Percent: pkg.referralLevels?.[0] || '',
      level2Percent: pkg.referralLevels?.[1] || '',
      level3Percent: pkg.referralLevels?.[2] || '',
      level4Percent: pkg.referralLevels?.[3] || '',
      level5Percent: pkg.referralLevels?.[4] || '',
      withdrawalFee: pkg.withdrawalFee || '',
      description: pkg.description || ''
    });
  };

  const handleDelete = async (packageId) => {
    if (!window.confirm('Are you sure you want to delete this package?')) return;

    try {
      await fetch(`${baseUrl}/${packageId}.json`, { method: 'DELETE' });
      await fetchPackages();
      alert('Package deleted!');
    } catch (error) {
      console.error('Error deleting package:', error);
      alert('Failed to delete package');
    }
  };

  // Predefined packages with Unlimited as string
  const predefinedPackages = [
    {
      name: 'PACKAGE 1',
      minInvestment: 16,
      maxInvestment: 999,
      durationDays: 365,
      dailyRoi: 1.5,
      roiCreditDays: 5,
      workingDays: 'Mon-Fri',
      referralLevels: [9, 7, 4, 2, 1],
      withdrawalFee: 10,
      description: 'Basic investment package'
    },
    {
      name: 'PACKAGE 2',
      minInvestment: 1000,
      maxInvestment: 4999,
      durationDays: 365,
      dailyRoi: 1.75,
      roiCreditDays: 5,
      workingDays: 'Mon-Fri',
      referralLevels: [11, 8, 5, 3, 2],
      withdrawalFee: 8,
      description: 'Standard investment package'
    },
    {
      name: 'PACKAGE 3',
      minInvestment: 5000,
      maxInvestment: 29999,
      durationDays: 365,
      dailyRoi: 2,
      roiCreditDays: 5,
      workingDays: 'Mon-Fri',
      referralLevels: [13, 10, 6, 4, 3],
      withdrawalFee: 6,
      description: 'Premium investment package'
    },
    {
      name: 'PACKAGE 4',
      minInvestment: 30000,
      maxInvestment: 69999,
      durationDays: 365,
      dailyRoi: 2.5,
      roiCreditDays: 5,
      workingDays: 'Mon-Fri',
      referralLevels: [15, 12, 7, 5, 4],
      withdrawalFee: 5,
      description: 'Elite investment package'
    },
    {
      name: 'PACKAGE 5',
      minInvestment: 70000,
      maxInvestment: 'Unlimited', // STRING
      durationDays: 365,
      dailyRoi: 3,
      roiCreditDays: 5,
      workingDays: 'Mon-Fri',
      referralLevels: [17, 14, 8, 6, 5],
      withdrawalFee: 4,
      description: 'Royal investment package - Unlimited maximum'
    }
  ];

  // Add predefined package
  const addPredefinedPackage = async (pkg) => {
    try {
      const packageId = pkg.name.toUpperCase().replace(/\s+/g, '_');
      
      const packageData = {
        ...pkg,
        maxInvestment: pkg.maxInvestment, // Keep as is (Unlimited stays string, numbers stay numbers)
        totalCommission: pkg.referralLevels.reduce((a, b) => a + b, 0),
        createdAt: new Date().toISOString()
      };

      await fetch(`${baseUrl}/${packageId}.json`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(packageData)
      });
      
      await fetchPackages();
      alert(`${pkg.name} added successfully!`);
    } catch (error) {
      console.error('Error adding predefined package:', error);
      alert('Failed to add package');
    }
  };

  // FIXED: Format currency to handle any string values
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '';
    
    // If it's a string that's not a number, return as is
    if (typeof amount === 'string' && isNaN(Number(amount))) {
      return amount; // Return "Unlimited", "Any", "∞", etc. as they are
    }
    
    // If it's a number or numeric string, format as currency
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Number(amount));
  };

  // FIXED: Safely check if a value is Unlimited or any other special string
  const isSpecialValue = (value) => {
    if (!value) return false;
    // Return true if it's a string that's not a number
    return typeof value === 'string' && isNaN(Number(value));
  };

  const getPackageColor = (name) => {
    switch(name) {
      case 'PACKAGE 1': return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
      case 'PACKAGE 2': return 'bg-green-500/20 text-green-400 border-green-500/30';
      case 'PACKAGE 3': return 'bg-purple-500/20 text-purple-400 border-purple-500/30';
      case 'PACKAGE 4': return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
      case 'PACKAGE 5': return 'bg-red-500/20 text-red-400 border-red-500/30';
      default: return 'bg-primary/20 text-primary border-primary/30';
    }
  };

  const toggleMobilePackage = (id) => {
    setExpandedMobilePackage(expandedMobilePackage === id ? null : id);
  };

  // Desktop Table Row Component
  const DesktopTableRow = ({ pkg }) => (
    <tr key={pkg.id} className="hover:bg-secondary/30 transition-colors">
      <td className="py-3 px-3">
        <div className="flex flex-col">
          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getPackageColor(pkg.name)} font-body max-w-fit`}>
            {pkg.name}
          </span>
          {pkg.description && (
            <div className="text-xs text-muted-foreground mt-1 font-body truncate max-w-[150px]">
              {pkg.description}
            </div>
          )}
        </div>
      </td>
      <td className="py-3 px-3">
        <div className="flex flex-col">
          <div className="text-sm text-silver-light font-body">
            {formatCurrency(pkg.minInvestment)}
          </div>
          <div className="text-xs text-muted-foreground font-body">Min</div>
        </div>
      </td>
      <td className="py-3 px-3">
        <div className="flex flex-col">
          <div className="text-sm text-silver-light font-body">
            {isSpecialValue(pkg.maxInvestment) ? pkg.maxInvestment : formatCurrency(pkg.maxInvestment)}
          </div>
          <div className="text-xs text-muted-foreground font-body">Max</div>
        </div>
      </td>
      <td className="py-3 px-3">
        <div className="flex items-center gap-1">
          <TrendingUp className="h-3 w-3 text-green-400" />
          <span className="text-sm text-green-400 font-body">{pkg.dailyRoi}%</span>
        </div>
      </td>
      <td className="py-3 px-3">
        <div className="text-xs text-muted-foreground font-body">{pkg.durationDays} days</div>
      </td>
      <td className="py-3 px-3">
        <div className="flex items-center gap-1">
          <Users className="h-3 w-3 text-primary" />
          <span className="text-xs text-silver-light font-body">
            {pkg.referralLevels?.slice(0, 3).join('/')}%
          </span>
        </div>
      </td>
      <td className="py-3 px-3">
        <div className="flex items-center gap-1">
          <Percent className="h-3 w-3 text-red-400" />
          <span className="text-xs text-red-400 font-body">{pkg.withdrawalFee}%</span>
        </div>
      </td>
      <td className="py-3 px-3">
        <div className="flex gap-2">
          <button
            onClick={() => handleEdit(pkg)}
            className="px-3 py-1 bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 rounded-lg transition-colors border border-blue-500/30 text-xs font-body"
            title="Edit"
          >
            <Edit2 size={14} />
          </button>
          <button
            onClick={() => handleDelete(pkg.id)}
            className="px-3 py-1 bg-red-600/20 hover:bg-red-600/30 text-red-400 rounded-lg transition-colors border border-red-500/30 text-xs font-body"
            title="Delete"
          >
            <Trash2 size={14} />
          </button>
        </div>
      </td>
    </tr>
  );

  // Mobile Accordion Item Component
  const MobileAccordionItem = ({ pkg, index }) => (
    <div key={pkg.id} className="card-glow mb-4 overflow-hidden">
      <div 
        className="p-4 bg-secondary hover:bg-secondary/80 transition-colors cursor-pointer flex justify-between items-center"
        onClick={() => toggleMobilePackage(pkg.id)}
      >
        <div className="flex items-center gap-3">
          <span className="text-silver font-body text-sm">#{index + 1}</span>
          <div className="text-left">
            <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${getPackageColor(pkg.name)} font-body`}>
              {pkg.name}
            </span>
            <div className="mt-1 text-xs text-muted-foreground font-body">
              {formatCurrency(pkg.minInvestment)} - {isSpecialValue(pkg.maxInvestment) ? pkg.maxInvestment : formatCurrency(pkg.maxInvestment)}
            </div>
          </div>
        </div>
        <ChevronDown className={`h-5 w-5 text-silver transition-transform ${
          expandedMobilePackage === pkg.id ? 'rotate-180' : ''
        }`} />
      </div>
      
      {expandedMobilePackage === pkg.id && (
        <div className="p-4 border-t border-border">
          {/* Package Details */}
          <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="bg-secondary/50 p-3 rounded-lg">
              <div className="text-xs text-silver font-body mb-1">Daily ROI</div>
              <div className="text-green-400 font-body flex items-center">
                <TrendingUp className="h-3 w-3 mr-1" />
                {pkg.dailyRoi}%
              </div>
            </div>
            <div className="bg-secondary/50 p-3 rounded-lg">
              <div className="text-xs text-silver font-body mb-1">Duration</div>
              <div className="text-foreground font-body flex items-center">
                <Calendar className="h-3 w-3 mr-1 text-muted-foreground" />
                {pkg.durationDays}d
              </div>
            </div>
            <div className="bg-secondary/50 p-3 rounded-lg">
              <div className="text-xs text-silver font-body mb-1">Withdrawal Fee</div>
              <div className="text-red-400 font-body flex items-center">
                <Percent className="h-3 w-3 mr-1" />
                {pkg.withdrawalFee}%
              </div>
            </div>
            <div className="bg-secondary/50 p-3 rounded-lg">
              <div className="text-xs text-silver font-body mb-1">Total Commission</div>
              <div className="text-primary font-body font-bold">
                {pkg.totalCommission || pkg.referralLevels?.reduce((a, b) => a + b, 0)}%
              </div>
            </div>
          </div>
          
          {/* Referral Levels */}
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2">
              <Users className="h-4 w-4 text-primary" />
              <h4 className="font-semibold text-foreground font-heading text-sm">Referral Levels</h4>
            </div>
            <div className="grid grid-cols-5 gap-2">
              {pkg.referralLevels?.map((percent, index) => (
                <div key={index} className="bg-secondary p-2 rounded-lg">
                  <div className="text-xs text-silver font-body text-center">L{index + 1}</div>
                  <div className="text-sm font-bold text-foreground font-heading text-center">
                    {percent}%
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Description */}
          {pkg.description && (
            <div className="mb-4 p-3 bg-secondary/30 rounded-lg">
              <div className="text-xs text-silver font-body mb-1">Description</div>
              <div className="text-sm text-foreground font-body">{pkg.description}</div>
            </div>
          )}
          
          {/* Actions */}
          <div className="flex gap-2 pt-4 border-t border-border">
            <button
              onClick={() => handleEdit(pkg)}
              className="flex-1 px-4 py-2 bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 rounded-lg transition-colors font-body flex items-center justify-center text-sm"
            >
              <Edit2 className="h-4 w-4 mr-2" />
              Edit
            </button>
            <button
              onClick={() => handleDelete(pkg.id)}
              className="flex-1 px-4 py-2 bg-red-600/20 hover:bg-red-600/30 text-red-400 rounded-lg transition-colors font-body flex items-center justify-center text-sm"
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Delete
            </button>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className="container-custom space-y-8">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-foreground font-heading">Manage Packages</h1>
          <p className="text-muted-foreground font-body text-sm md:text-base">Configure investment packages and commissions</p>
        </div>
        <button
          onClick={() => setShowAddForm(!showAddForm)}
          className="btn-electric flex items-center gap-2 px-4 py-2 md:px-6 md:py-3 font-bold rounded-xl text-sm md:text-base"
        >
          {showAddForm ? <X size={18} /> : <Plus size={18} />}
          {showAddForm ? 'Cancel' : 'Add Package'}
        </button>
      </div>

      <div className="card-glow p-4 md:p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-foreground font-heading">Activation Bonus Rule</h2>
            <p className="text-xs md:text-sm text-muted-foreground font-body">
              Add a working wallet bonus for users who activate multiple packages quickly.
            </p>
          </div>
          <button
            onClick={saveActivationBonusRule}
            disabled={activationRuleStatus.loading || activationRuleStatus.saving}
            className="btn-electric px-4 py-2 rounded-lg font-bold text-sm md:text-base disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {activationRuleStatus.saving ? 'Saving...' : 'Save Rule'}
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-4">
          <label className="flex items-center gap-2 text-silver font-body text-sm">
            <input
              type="checkbox"
              checked={activationBonusRule.enabled}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, enabled: e.target.checked })}
              className="h-4 w-4"
            />
            Enabled
          </label>
          <div>
            <label className="block text-silver mb-2 font-body text-sm">Required Packages</label>
            <input
              type="number"
              min="1"
              value={activationBonusRule.requiredPackages}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, requiredPackages: e.target.value })}
              className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 text-foreground font-body text-sm md:text-base"
            />
          </div>
          <div>
            <label className="block text-silver mb-2 font-body text-sm">Window (Days)</label>
            <input
              type="number"
              min="1"
              value={activationBonusRule.windowDays}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, windowDays: e.target.value })}
              className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 text-foreground font-body text-sm md:text-base"
            />
          </div>
          <div>
            <label className="block text-silver mb-2 font-body text-sm">Bonus Amount ($)</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={activationBonusRule.bonusAmount}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, bonusAmount: e.target.value })}
              className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 text-foreground font-body text-sm md:text-base"
            />
          </div>
          <div>
            <label className="block text-silver mb-2 font-body text-sm">Wallet</label>
            <select
              value={activationBonusRule.wallet}
              onChange={(e) => setActivationBonusRule({ ...activationBonusRule, wallet: e.target.value })}
              className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 text-foreground font-body text-sm md:text-base"
              disabled
            >
              <option value="working">Working Wallet</option>
            </select>
          </div>
        </div>
      </div>

      {/* Quick Add Predefined Packages */}
      <div className="card-glow p-4 md:p-6">
        <h2 className="text-lg md:text-xl font-bold text-foreground mb-4 font-heading">Quick Add Packages</h2>
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {predefinedPackages.map((pkg, index) => (
            <button
              key={index}
              onClick={() => addPredefinedPackage(pkg)}
              className="card-glow p-3 md:p-4 text-left transition-all hover:scale-105 hover:shadow-electric"
            >
              <div className="font-bold text-foreground font-heading text-sm md:text-base">{pkg.name}</div>
              <div className="text-xs md:text-sm text-primary mt-1 font-body">
                ${pkg.minInvestment} - {pkg.maxInvestment === 'Unlimited' ? 'Unlimited' : `$${pkg.maxInvestment}`}
              </div>
              <div className="text-xs text-muted-foreground mt-2 font-body">
                ROI: {pkg.dailyRoi}% | Levels: {pkg.referralLevels.slice(0, 3).join('/')}%
              </div>
              {pkg.maxInvestment === 'Unlimited' && (
                <span className="mt-2 inline-flex items-center px-2 py-0.5 bg-red-500/20 text-red-400 text-xs rounded-full border border-red-500/30">
                  Unlimited Max
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Add/Edit Form */}
      {showAddForm && (
        <div className="card-glow p-4 md:p-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground mb-6 font-heading">
            {editingId ? 'Edit Package' : 'Add New Package'}
          </h2>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {/* Package Name */}
              <div>
                <label className="block text-silver mb-2 font-body text-sm">Package Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                  placeholder="e.g., PACKAGE 1"
                  required
                />
              </div>

              {/* Min Investment */}
              <div>
                <label className="block text-silver mb-2 font-body text-sm">Min Investment ($) *</label>
                <input
                  type="number"
                  name="minInvestment"
                  value={formData.minInvestment}
                  onChange={handleChange}
                  className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                  required
                  min="0"
                />
              </div>

              {/* Max Investment - DYNAMIC: Accept any text */}
              <div>
                <label className="block text-silver mb-2 font-body text-sm">Max Investment *</label>
                <input
                  type="text"
                  name="maxInvestment"
                  value={formData.maxInvestment}
                  onChange={handleChange}
                  className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                  placeholder="e.g., Unlimited, Any, ∞, 10000"
                  required
                />
                {formData.maxInvestment && (
                  <div className="mt-1 text-xs text-green-400">
                    ✓ Will be saved as "{formData.maxInvestment}" in database
                  </div>
                )}
              </div>

              {/* Daily ROI */}
              <div>
                <label className="block text-silver mb-2 font-body text-sm">Daily ROI (%) *</label>
                <input
                  type="number"
                  step="0.01"
                  name="dailyRoi"
                  value={formData.dailyRoi}
                  onChange={handleChange}
                  className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                  required
                />
              </div>

              {/* Duration */}
              <div>
                <label className="block text-silver mb-2 font-body text-sm">Duration (Days)</label>
                <input
                  type="number"
                  name="durationDays"
                  value={formData.durationDays}
                  onChange={handleChange}
                  className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                />
              </div>

              {/* ROI Credit Days */}
              <div>
                <label className="block text-silver mb-2 font-body text-sm">ROI Credit Every (Days)</label>
                <input
                  type="number"
                  name="roiCreditDays"
                  value={formData.roiCreditDays}
                  onChange={handleChange}
                  className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                />
              </div>

              {/* Working Days */}
              <div>
                <label className="block text-silver mb-2 font-body text-sm">Working Days (ROI)</label>
                <select
                  name="workingDays"
                  value={formData.workingDays}
                  onChange={handleChange}
                  className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                >
                  <option value="Mon-Fri">Mon-Fri (Weekdays)</option>
                  <option value="Mon-Sat">Mon-Sat (6 Days)</option>
                  <option value="All">All Days</option>
                </select>
              </div>

              {/* Withdrawal Fee */}
              <div>
                <label className="block text-silver mb-2 font-body text-sm">Withdrawal Fee (%)</label>
                <input
                  type="number"
                  step="0.01"
                  name="withdrawalFee"
                  value={formData.withdrawalFee}
                  onChange={handleChange}
                  className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                />
              </div>
            </div>

            {/* Referral Levels */}
            <div className="bg-secondary/50 border border-border rounded-xl p-4 md:p-6 card-glow">
              <h3 className="text-lg md:text-xl font-bold text-foreground mb-4 font-heading">Referral Commission Levels</h3>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
                {[1, 2, 3, 4, 5].map(level => (
                  <div key={level}>
                    <label className="block text-silver mb-2 font-body text-sm">Level {level} (%)</label>
                    <input
                      type="number"
                      step="0.01"
                      name={`level${level}Percent`}
                      value={formData[`level${level}Percent`]}
                      onChange={handleChange}
                      className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                      placeholder={`L${level} %`}
                    />
                  </div>
                ))}
              </div>
              <div className="mt-4 text-right">
                <span className="text-muted-foreground font-body text-sm md:text-base">Total Commission: </span>
                <span className="text-xl md:text-2xl font-bold text-primary font-heading">
                  {calculateTotalCommission().toFixed(1)}%
                </span>
              </div>
            </div>

            {/* Description */}
            <div>
              <label className="block text-silver mb-2 font-body text-sm">Description</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="3"
                className="w-full bg-secondary/80 border border-border rounded-lg px-3 py-2 md:px-4 md:py-3 text-foreground font-body text-sm md:text-base"
                placeholder="Package description..."
              />
            </div>

            {/* Form Actions */}
            <div className="flex gap-4 pt-4">
              <button
                type="submit"
                className="btn-electric px-6 py-2 md:px-8 md:py-3 font-bold rounded-xl text-sm md:text-base"
              >
                {editingId ? 'Update Package' : 'Create Package'}
              </button>
              <button
                type="button"
                onClick={resetForm}
                className="px-6 py-2 md:px-8 md:py-3 bg-secondary hover:bg-secondary/80 text-foreground font-bold rounded-xl transition-colors border border-border text-sm md:text-base"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Desktop Table View */}
      <div className="hidden lg:block card-glow overflow-hidden">
        <div className="p-4 md:p-6 border-b border-border">
          <h2 className="text-xl font-bold text-foreground font-heading">Existing Packages ({packages.length})</h2>
        </div>

        {loading ? (
          <div className="p-8 text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mx-auto"></div>
            <p className="text-muted-foreground mt-4 font-body">Loading packages...</p>
          </div>
        ) : packages.length === 0 ? (
          <div className="p-8 text-center text-muted-foreground font-body">
            No packages found. Add your first package.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-max">
              <thead className="bg-secondary/50">
                <tr>
                  <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-32">Package</th>
                  <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-24">Min</th>
                  <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-24">Max</th>
                  <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">ROI</th>
                  <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">Duration</th>
                  <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">Commissions</th>
                  <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-20">Fee</th>
                  <th className="py-3 px-3 text-left text-silver font-semibold text-xs font-body w-24">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {packages.map(pkg => (
                  <DesktopTableRow key={pkg.id} pkg={pkg} />
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Mobile Accordion View */}
      <div className="lg:hidden">
        <div className="mb-4">
          <h2 className="text-xl font-bold text-foreground font-heading">Existing Packages ({packages.length})</h2>
        </div>

        {loading ? (
          <div className="p-8 text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mx-auto"></div>
            <p className="text-muted-foreground mt-4 font-body">Loading packages...</p>
          </div>
        ) : packages.length === 0 ? (
          <div className="p-8 text-center text-muted-foreground font-body">
            No packages found. Add your first package.
          </div>
        ) : (
          <div>
            {packages.map((pkg, index) => (
              <MobileAccordionItem key={pkg.id} pkg={pkg} index={index} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddPackage;
